export const K5_TRAINING_COURSE_CODE = 'k-5_training_tier1'
export const MS_TRAINING_COURSE_CODE = '6-8_training_tier1'
export const HS_TRAINING_COURSE_CODE = 'highschool'

export const K5_CORE_TRAINING_COURSE_CODE = 'k-5_core-training_tier-1_educator'
export const MS_CORE_TRAINING_COURSE_CODE = '6-8_core-training_tier-1_educator'

// Explicit K8 training course codes only. Do NOT use a broad /training/i match —
// DWB courses like `k-5_dwb-training_tier-1_educator` must keep using makeAttemptV2Direct.
export const K8_TRAINING_COURSE_CODES = new Set([
  K5_TRAINING_COURSE_CODE,
  MS_TRAINING_COURSE_CODE,
  K5_CORE_TRAINING_COURSE_CODE,
  MS_CORE_TRAINING_COURSE_CODE,
])
